module.exports = __webpack_public_path__ + "img/270.f4253203.jpg";